import HTTPService from './HTTP.service';
import PartnerService from './Partner.service';

const request = require('superagent');

class WidgetService {
	async gotoSkiBro(config){
		const { dateStart, dateEnd, selectedResort, selectedLessonType, pageHitId } = config;

		if (dateStart>dateEnd){
			return alert('Sorry, your Start Date must be before your End Date');
		}

		const url = `${HTTPService.getURLForService('bookByLesson')}/${pageHitId}/${dateStart}/${dateEnd}/${selectedResort}/${selectedLessonType}`;
		let target = 'skibro';
		
		if (selectedResort == null || selectedLessonType == null) return alert('Please select your holiday dates, resort and type of lesson');
		if (dateStart == null || dateEnd == null) return alert('Date From and Date To must be set');
		if (dateStart > dateEnd) return alert('End date must be the same as the start date, or a future date');

		window.open(url, target);
	}
	async getWidgetData() {
		const { partnerId }= await PartnerService.getPartnerId();

		return new Promise((resolve, reject) => {

			let uri = `${HTTPService.getURLForService('get-widget-data')}?partnerId=${partnerId}`

			request
				.get(uri)
				.set('Accept', 'application/json')
				.end((err, res) => {
					if (err) {
						console.log('Error: ' + err);
						reject(err);
					}
					const data = res.body.data;
					resolve(data);
				});
		});
	}
}
const widgetService = new WidgetService();

export default widgetService;


// WEBPACK FOOTER //
// ./src/services/Widget.service.js